/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Inbox_Count_BlockedInputs */

const en_inbox_count_blocked = /** @type {(inputs: Inbox_Count_BlockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} things waiting for you`)
};

const id_inbox_count_blocked = /** @type {(inputs: Inbox_Count_BlockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} hal menunggu kamu`)
};

/**
* | output |
* | --- |
* | "{n} things waiting for you" |
*
* @param {Inbox_Count_BlockedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_count_blocked = /** @type {((inputs: Inbox_Count_BlockedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Count_BlockedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_count_blocked(inputs)
	return en_inbox_count_blocked(inputs)
});